<div class="views-container mt-0">
  <mat-dialog-content>
    <div class="mw-600">
      @if (!!commandProgress) {
        <p (click)="refreshRunning()" class="m-0 mr-2 float-right">
          @if (!commandProgress?.progressInfo?.isCompleted && !commandProgress?.progressInfo?.isFailure) {
            <i class="now-ui-icons loader_refresh" [ngClass]="{'spin': isRefreshRunning}"></i>
          }
        </p>
        <h4>Executing command</h4>
        <div class="mxw-600">
          <div class="d-flex flex-row justify-content-between text-muted">
            <p>Command</p>
            <p>Status</p>
          </div>
          <app-command-progress-info [commandProgress]="commandProgress"></app-command-progress-info>
        </div>
      } @else {
        <ng-content></ng-content>
      }
    </div>
  </mat-dialog-content>
</div>

